import { globalSearchReset, setCardStatus, setMultipleCardStatus, updateCardModalFormValues } from 'actions/cardActions';
import { CardDetails } from 'containers/cards/cards';
import { SelectStatusFormValues } from 'features/cards/components/edit-single-card-status/SelectStatusForm';
import useConfirmReplacementCardModal from 'features/cards/components/edit-single-card-status/useConfirmReplacementCardModal';
import useConfirmStatusModal from 'features/cards/components/edit-single-card-status/useConfirmStatusModal';
import useUpdateCardDetailsModal from 'features/cards/components/edit-single-card-status/useUpdateCardDetailsModal';
import useEditCardModal from 'features/cards/components/new-card-modal/edit-card-modal/useEditCardModal';
import useMultiEditCardModal from 'features/cards/components/new-card-modal/multi-edit-card-modal/useMultiEditCardModal';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackCustomEvent } from 'utilities/app-insights';
import { cardStatuses } from 'utilities/card-utilities';

/**
 * Fully encapsulated hook for editing the status of one or many cards
 * Just call open(values: SelectStatusFormValues) to start the process
 */
export default function useCardEditStatusModal(
  cardsList: any[],
  onCloseForm: () => void,
  cardsDetailList?: CardDetails[],
  useMultiEdit?: boolean
) {
  const dispatch = useDispatch();

  const [status, setStatus] = useState(null);

  function closeForm() {
    onCloseForm();
    editCardModal.close();
    confirmStatusModal.close();
  }

  const editCardModal = useEditCardModal(status, closeForm);
  const multiEditModal = useMultiEditCardModal();

  const confirmStatusModal = useConfirmStatusModal({
    status,
    onConfirm: onStatusOnlyUpdate,
  });

  const updateCardDetailModal = useUpdateCardDetailsModal({
    onYesClick: () => {
      if (useMultiEdit) multiEditModal.open(cardsDetailList, status);
      else editCardModal.open();
    },
    onNoClick: () => onConfirmReplaceCard(),
  });

  const confirmReplacementCardModal = useConfirmReplacementCardModal({
    status,
    cardsList,
    onStatusOnlyUpdate,
    onReplaceCard,
  });

  
  const assignedGrandfatherClientNumber = useSelector((state: any) => state.userStore.assignedGrandfatherClientNumber);
  const loggedInUser = useSelector((state: any) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state: any) => state.userStore.assignedAccountNumber);
  const isGlobalSearchLoaded = useSelector((state: any) => state.cardsStore.globalSearchLoaded);

  const updateStatus = (reissueCard: boolean) => {
    const isMultipleCards = cardsList.length > 1;
    if (isMultipleCards) {
      dispatch(setMultipleCardStatus(cardsList.join(';'), status, assignedGrandfatherClientNumber, reissueCard));
    } else {
      dispatch(setCardStatus(cardsList[0], status, assignedGrandfatherClientNumber, reissueCard));
    }

    trackCustomEvent(
      'Submit Update Status',
      loggedInUser,
      assignedAccountNumber,
      'Clicked Submit to submit Update Card(s) Status.',
      { selectedCard: cardsList }
    );

    if (isGlobalSearchLoaded) {
      dispatch(globalSearchReset());
    }
  };

  function onConfirmReplaceCard() {
    updateStatus(true);
    closeForm();
    dispatch(updateCardModalFormValues({}));
  }

  function onReplaceCard() {
    updateCardDetailModal.open();
  }

  function onStatusOnlyUpdate() {
    updateStatus(false);
    closeForm();
    dispatch(updateCardModalFormValues({}));
  }

  function open(values: SelectStatusFormValues) {
    setStatus(values.cardStatus);

    const willCauseReissue = cardStatuses.find(
      (status) => status.label === values.cardStatus
    ).willReissue;
    if (willCauseReissue) {
      confirmReplacementCardModal.open();
    } else confirmStatusModal.open();
  }

  return {
    open,
  }; 
}